// src/components/Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h4>Royal Suites Service Apartments</h4>
          <p>Providing luxurious and comfortable stays in Gachibowli for business and leisure travelers.</p>
        </div>
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>Email: kumarreddy892@gmail.com</p>
          <p>Phone: 9848811588</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Royal Suites Service Apartments. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
